module.exports = __webpack_public_path__ + "images/CEBSB_goodnews_bg_up.1782880901430.png";